module.exports = __webpack_public_path__ + "img/icon4.05bcc609.png";